<template>
	<page>
		<module title="基本信息" height="auto">
			<c-detail >
				<c-detail-item label="订单类型" >
					{{orderTypeName[orderDetail.order_type]}}
				</c-detail-item>
				<c-detail-item label="业务单号" >
					{{orderDetail.order_number}}
				</c-detail-item>
				<c-detail-item label="下单会员" >
					{{orderDetail.nick_name}}【{{orderDetail.user_manage_mobilephone}}】
				</c-detail-item>
				<c-detail-item label="下单会员等级" >
					{{orderDetail.level_name}}
				</c-detail-item>
				<c-detail-item label="下单时间" >
					{{orderDetail.create_date}}
				</c-detail-item>
				<c-detail-item label="支付时间" >
					{{orderDetail.payment_date}}
				</c-detail-item>
				<c-detail-item label="商品数量" >
					{{orderDetail.product_count}}
				</c-detail-item>
				<c-detail-item label="订单商品金额" >
            <span v-if="orderDetail.product_money">
                ￥{{parseFloat(orderDetail.product_money).toFixed(2)}}
            </span>
            <span v-else-if="orderDetail.payment_money">
                ￥{{parseFloat(orderDetail.payment_money).toFixed(2)}}
            </span>
				</c-detail-item>
			</c-detail>
		</module>
		
		<module title="清分信息">
			<div style="padding: 30px 30px 40px;">
				<c-table v-model="rewardRecordList" height="auto" :paging="false" border>
					<c-table-column
						label="奖励会员"
						name="reward_nick_name"
                        width="180"
					>
						<template v-slot="{data}">
						  {{data.reward_nick_name}}
                          <span v-if="data.reward_user_manage_mobilephone">
                              【{{data.reward_user_manage_mobilephone}}】
                          </span>
						</template>
					</c-table-column>

					<c-table-column
						label="奖励会员等级"
						name="reward_user_level_name"
                        width="100"
					>
					</c-table-column>

					<c-table-column
						label="奖励类型"
						name="reward_type"
                        width="80"
                    >
						<template v-slot="{data}">
							{{rewardTypeName[data.reward_type]||'其他'}}
						</template>
					</c-table-column>

					<c-table-column
						label="预计奖励金额"
						name="record_money"
            width="110"
          >
						<template v-slot="{data}">
              <span>¥{{parseFloat(data.original_record_money).toFixed(2)}}</span>
						</template>
					</c-table-column>

          <c-table-column
              label="取消奖励金额"
              name="record_money"
              width="110"
          >
            <template v-slot="{data}">
              <span v-if="parseFloat(data.original_record_money)!=parseFloat(data.estimated_record_money)" style="color: red">¥{{(parseFloat(data.original_record_money) - parseFloat(data.estimated_record_money)).toFixed(2)}}</span>
              <span v-else>¥{{(parseFloat(data.original_record_money) - parseFloat(data.estimated_record_money)).toFixed(2)}}</span>
            </template>
          </c-table-column>

					<c-table-column
						label="实际奖励金额"
						name="record_money"
            width="110"
          >
						<template v-slot="{data}">
              <span v-if="data.state == 2">¥{{parseFloat(data.estimated_record_money).toFixed(2)}}</span>
              <span v-else>--</span>
						</template>
					</c-table-column>

					<c-table-column
						label="结算状态"
						name="state"
            width="80"
          >
						<template v-slot="{data}">
							<span v-if="data.state == 0" style="color:darkgray"> {{stateName[data.state]}} </span>
							<span v-else-if="data.state == 1" style="color:#2348d0"> {{stateName[data.state]}} </span>
							<span v-else-if="data.state == 2" style="color:darkgreen"> {{stateName[data.state]}} </span>
							<span v-else> {{stateName[data.state]}} </span>
						</template>
					</c-table-column>

					<c-table-column
						label="清分结算时间"
						name="settlement_date"
            width="150"
          >
						<template v-slot="row">
							{{row.data.settlement_date||'--'}}
						</template>
					</c-table-column>

					<c-table-column
						label="备注"
						name="remark"
            width="300"
          >
            <template v-slot="row">
              {{row.data.remark||'--'}}
            </template>
					</c-table-column>

					<c-table-column
						type="button"
						fixed="right"
						label="操作"
						width="100"
					>
						<template v-slot="{data}">
							<c-table-button @click="rejected(data)" v-if="data.state == 1 ">取消结算</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</div>
		</module>
		
		<c-dialog ref="rejectedReason" title="取消原因" width="400" @resolve="rejectedHandle">
			<div class="rejected-eason">
				<textarea v-model="rejectedReason" placeholder="请输入取消结算原因..."></textarea>
			</div>
		</c-dialog>


	</page>
</template>

<script>
	export default {
		name: 'order_reward_record_detail',
		props: {
			orderNumber: String
		},
		data() {
			return {
                orderTypeName: {
                    1: '普通',
                    2: '积分',
                    3: '购买代理卡',
                    4: '砍价',
                    5: '预定（全款）',
                    6: '预定（定金）',
                    7: '定制',
                    8: '拼团',
                    9: '云仓提货',
                    10: '送礼',
                    11: '抽奖'
                },
				stateName: {
					0: '取消清分',
					1: '待清分',
					2: '已经清分'
				},
				rewardTypeName: {
					1: '分销差价',
					2: '直推奖励',
					3: '间推奖励',
					4: '区代奖励',
					22: '平级奖励',
					99: '平台收益'
				},
				orderDetail: {},
				rewardRecordList: [],
				rejectedReason: '',
			}
		},
		watch:{//ID变更刷新页面
			orderNumber(){
				this.detail();
			}
		},
		mounted() {
			this.detail();
		},
		computed: {

		},
		methods: {
			detail() {
				this.request({
					url: '/reward/record/detail',
					data: {order_number: this.orderNumber},
					loading: true,
					success: data => {
						this.orderDetail = data.order_info;
						this.rewardRecordList = data.reward_records;
					}
				});
			},
			//驳回弹框
			rejected(data) {
				this.t_data = data;
				this.$refs.rejectedReason.open();
			},
			//取消驳回提交
			rejectedHandle(stop){

				if (!this.rejectedReason.trim()) {
					this.$message({
						text: '请填写取消结算原因'
					});
					stop();
					return;
				}
				this.request({
					url: '/reward/record/cancel',
					data: {id:this.t_data.id,reject_reason:this.rejectedReason.trim()},
					loading: true,
					success: data => {
						this.$message({
							text: '取消结算成功',
							icon: 'success'
						});
						this.t_data.state = 0;
						this.t_data.remark = this.rejectedReason.trim();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.rejected-eason {
		padding: 20px;

		textarea {
			box-sizing: border-box;
			width: 100%;
			height: 120px;
			border: none;
			padding: 10px 14px;
			line-height: 20px;
			background: #FAFAFA;
			resize: none;
		}
	}
  a {
    color: #003DD9;
  }
</style>